// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-appearance-sidebar-edit-widgets-list .widgets-list {
  width: 235px;
}
fi-appearance-sidebar-edit-widgets-list fi-widget {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./Source/app/appearance/sidebar/edit/widgets-list/widgets-list.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR;AAGI;EACI,eAAA;AADR","sourcesContent":["fi-appearance-sidebar-edit-widgets-list {\r\n    .widgets-list {\r\n        width: 235px;\r\n    }\r\n\r\n    fi-widget {\r\n        cursor: pointer;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
